import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow-lg p-8" }
const _hoisted_2 = { class: "text-center mb-8" }
const _hoisted_3 = { class: "text-3xl font-bold text-gray-800 mb-4" }
const _hoisted_4 = { class: "grid md:grid-cols-2 gap-8" }
const _hoisted_5 = { class: "flex items-center mb-4" }
const _hoisted_6 = { class: "w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center text-white text-xl mr-4" }
const _hoisted_7 = { class: "text-xl font-semibold text-gray-800" }
const _hoisted_8 = { class: "text-gray-600 mb-4 leading-relaxed" }
const _hoisted_9 = { class: "flex flex-wrap gap-2 mb-4" }
const _hoisted_10 = { class: "flex space-x-4" }
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('projects.title')), 1),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "w-20 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto rounded" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
        return (_openBlock(), _createElementBlock("div", {
          key: project.name,
          class: "bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg p-6 hover:shadow-lg transition-all duration-300 hover:transform hover:-translate-y-1"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(project.icon), 1),
            _createElementVNode("h3", _hoisted_7, _toDisplayString(project.name), 1)
          ]),
          _createElementVNode("p", _hoisted_8, _toDisplayString(project.description), 1),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.technologies, (tech) => {
              return (_openBlock(), _createElementBlock("span", {
                key: tech,
                class: "bg-blue-100 text-blue-800 px-2 py-1 rounded text-sm font-medium"
              }, _toDisplayString(tech), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("a", {
              href: project.link,
              target: "_blank",
              class: "bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center"
            }, [
              _cache[1] || (_cache[1] = _createElementVNode("svg", {
                class: "w-4 h-4 mr-2",
                fill: "currentColor",
                viewBox: "0 0 20 20"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z",
                  "clip-rule": "evenodd"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('projects.viewProject')), 1)
            ], 8, _hoisted_11),
            _createElementVNode("a", {
              href: project.github,
              target: "_blank",
              class: "border border-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-50 transition-colors flex items-center"
            }, [
              _cache[2] || (_cache[2] = _createElementVNode("svg", {
                class: "w-4 h-4 mr-2",
                fill: "currentColor",
                viewBox: "0 0 20 20"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z",
                  "clip-rule": "evenodd"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('projects.viewGithub')), 1)
            ], 8, _hoisted_12)
          ])
        ]))
      }), 128))
    ])
  ]))
}